import { render, staticRenderFns } from "./invoiceClassSelect.vue?vue&type=template&id=0dd822fe&"
import script from "./invoiceClassSelect.vue?vue&type=script&lang=js&"
export * from "./invoiceClassSelect.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports